import { useState, useEffect } from 'react';
import Header from './include/header';
import Footer from './include/footer';
import LeftPanel from './include/leftpanel';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Global from '../APIConfig';
import AuthUser from "../AuthUser";
import PickupChart from './Charts/PickupChart';
import BagsChart from './Charts/BagsChart';
import ManifestChart from './Charts/ManifestChart';
import DrsChart from './Charts/DrsChart';

function OperationalDashBoard() {
    let navigate = useNavigate();
    const{headers1,logout}=AuthUser();
    const [totalpickup, setTotalpickup] = useState(0);
    const [totalbags, setTotalbags] = useState(0);
    const [totalmanifests, setTotalmanifests] = useState(0);
    const [totalDRS, setTotalDRS] = useState(0);

    useEffect(() => {
        Get30Dayspickup();
        Get30DaysBags();
        Get30DaysManifests();
        Get30DaysDRS();
      }, []);
      const Get30Dayspickup=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Get30DaysPickup',
            headers:headers1,
            data: {
            }
          })
          .then(function (response) {
            console.log(response.data);
            if(response.data.status == 200)
            {
                var data=response.data;
                setTotalpickup(data.label);
                
            }
            else
            {
                setTotalpickup(0);
                
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
        }
        const Get30DaysBags=()=>{
            axios({
                method: 'post',
                url: Global.baseUrl+'Get30DaysBags',
                headers:headers1,
                data: { 
                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    var data=response.data;
                    setTotalbags(data.label);
                }
                else
                {
                    setTotalbags(0);
                }
            })
            .catch(function (error) {
                if(error.response.status==401){
                    logout();
                    navigate('/');
                    window.location.reload();
                }   
            });
        }
        const Get30DaysManifests=()=>{
            axios({
                method: 'post',
                url: Global.baseUrl+'Get30DaysManifests',
                headers:headers1,
                data: {
                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    var data=response.data;
                    setTotalmanifests(data.label);
                }
                else
                {
                    setTotalmanifests(0);
                }
            })
            .catch(function (error) {
                if(error.response.status==401){
                    logout();
                    navigate('/');
                    window.location.reload();
                }  
            });
        }
        const Get30DaysDRS=()=>{
            axios({
                method: 'post',
                url: Global.baseUrl+'Get30DaysDRS',
                headers:headers1,
                data: { 
                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    var data=response.data;
                    setTotalDRS(data.label);
                }
                else
                {
                    setTotalDRS(0);
                }
            })
            .catch(function (error) {
                if(error.response.status==401){
                    logout();
                    navigate('/');
                    window.location.reload();
                }  
            });
        }

        
  return (
    <>
        <LeftPanel/>
        <main className='home-section'>
        <Header/>
        <div className="overlay"></div>
        <div className='col-12 mt-4'><h2>Operational Dashboard</h2></div>
        
            <div className="row dash_state_box">
                <div className="col-12 col-sm-6 col-xl-3 mb-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <div className="row d-block d-xl-flex align-items-center">
                                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                    <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                        <i className="bx bx-collection"></i>
                                    </div>
                                    <div className="d-sm-none">
                                        <h2 className="fw-extrabold h5"> Pickup</h2>
                                        <h3 className="mb-1">{totalpickup}</h3>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-7 px-xl-0">
                                    <div className="d-none d-sm-block">
                                        <h2 className=""> Pickup</h2>
                                        <h3 className="">{totalpickup}</h3>
                                    </div>
                                    <small className="">
                                        Last 30 days
                                    </small> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-xl-3 mb-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <div className="row d-block d-xl-flex align-items-center">
                                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                    <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                        <i className="bx bx-cuboid"></i>
                                    </div>
                                    <div className="d-sm-none">
                                        <h2 className="fw-extrabold h5"> Bags</h2>
                                        <h3 className="mb-1">{totalbags}</h3>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-7 px-xl-0">
                                    <div className="d-none d-sm-block">
                                        <h2 className=""> Bags</h2>
                                        <h3 className="">{totalbags}</h3>
                                    </div>
                                    <small className="">
                                        Last 30 days
                                    </small> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-xl-3 mb-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <div className="row d-block d-xl-flex align-items-center">
                                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                    <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                        <i className="bx bx-package"></i>
                                    </div>
                                    <div className="d-sm-none">
                                        <h2 className="fw-extrabold h5"> Manifests</h2>
                                        <h3 className="mb-1">{totalmanifests}</h3>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-7 px-xl-0">
                                    <div className="d-none d-sm-block">
                                        <h2 className=""> Manifests</h2>
                                        <h3 className="">{totalmanifests}</h3>
                                    </div>
                                    <small className="">
                                        Last 30 days
                                    </small> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-xl-3 mb-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <div className="row d-block d-xl-flex align-items-center">
                                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                    <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                        <i className="bx bx-run"></i>
                                    </div>
                                    <div className="d-sm-none">
                                        <h2 className="fw-extrabold h5"> DRS</h2>
                                        <h3 className="mb-1">{totalDRS}</h3>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-7 px-xl-0">
                                    <div className="d-none d-sm-block">
                                        <h2 className=""> DRS</h2>
                                        <h3 className="">{totalDRS}</h3>
                                    </div>
                                    <small className="">
                                        Last 30 days
                                    </small> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12 col-md-8'>
                        <section className="mb-3">
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="shipment_card_st shadow-sm">
                                        <PickupChart/>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="sales_card_st shadow-sm">
                                        <BagsChart/>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 mt-3">
                                    <div className="shipment_card_st shadow-sm">
                                        <ManifestChart/>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 mt-3">
                                    <div className="sales_card_st shadow-sm">
                                        <DrsChart/>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className='col-12 col-md-4'>
                        <div className="row">
                            <div className="list-group">
                                <a href="#"  className="list-group-item list-group-item-action active">
                                    Shipments Management
                                </a>
                                <a href="/Shipmentlist/All" className="list-group-item list-group-item-action">Add Shipment</a>
                                <a href="/Shipmentlist/B" className="list-group-item list-group-item-action">Undelivered Shipment</a>
                                <a href="/Shipmentlist/D" className="list-group-item list-group-item-action">Delivered Shipment</a>
                                <a href="/Shipmentlist/C" className="list-group-item list-group-item-action">Cancel Shipment</a>
                            </div>
                            <div className="list-group mt-4">
                                <a href="#"  className="list-group-item list-group-item-action active">
                                    Pickup (PRS) Management
                                </a>
                                <a href="/PickupList/Generatepickup" className="list-group-item list-group-item-action">Add PRS</a>
                                <a href="/PickupList/Running" className="list-group-item list-group-item-action">Runinng PRS</a>
                                <a href="/PickupList/Completed" className="list-group-item list-group-item-action">Complete PRS</a>
                            </div>
                            <div className="list-group mt-4">
                                <a href="#"  className="list-group-item list-group-item-action active">
                                    Bag Management
                                </a>
                                <a href="/BagList/AddBag" className="list-group-item list-group-item-action">Add Bag</a>
                                <a href="/BagList/Running" className="list-group-item list-group-item-action">Runinng Bag</a>
                                <a href="/BagList/Completed" className="list-group-item list-group-item-action">Complete Bag</a>
                            </div>
                            <div className="list-group mt-4">
                                <a href="#"  className="list-group-item list-group-item-action active">
                                    Bag Manifest Management
                                </a>
                                <a href="/BagManifestList/AddBagManifest" className="list-group-item list-group-item-action">Add Bag Manifests</a>
                                <a href="/BagManifestList/Running" className="list-group-item list-group-item-action">Runinng Bag Manifests</a>
                                <a href="/BagManifestList/Completed" className="list-group-item list-group-item-action">Complete Bag Manifests</a>
                            </div>
                            <div className="list-group mt-4">
                                <a href="#"  className="list-group-item list-group-item-action active">
                                    Shipment Manifest Management
                                </a>
                                <a href="/ShipmentManifestList/AddShipmentManifest" className="list-group-item list-group-item-action">Add Shipment Manifests</a>
                                <a href="/ShipmentManifestList/Running" className="list-group-item list-group-item-action">Runinng Shipment Manifests</a>
                                <a href="/ShipmentManifestList/Completed" className="list-group-item list-group-item-action">Complete Shipment Manifests</a>
                            </div>
                            <div className="list-group mt-4">
                                <a href="#"  className="list-group-item list-group-item-action active">
                                    DRS Management
                                </a>
                                <a href="/DrsList/AddDrs" className="list-group-item list-group-item-action">Add DRS</a>
                                <a href="/DrsList/Running" className="list-group-item list-group-item-action">Runinng DRS</a>
                                <a href="/DrsList/Completed" className="list-group-item list-group-item-action">Complete DRS</a>
                            </div>
                            <div className="list-group mt-4">
                                <a href="#"  className="list-group-item list-group-item-action active">
                                    DRS Management
                                </a>
                                <a href="/WarehouseScanner/Pickup" className="list-group-item list-group-item-action">Scan Pickup Shipments</a>
                                <a href="/WarehouseScanner/Manifested_Bag" className="list-group-item list-group-item-action">Scan Manifested Bags</a>
                                <a href="/WarehouseScanner/Manifested_Shipment" className="list-group-item list-group-item-action">Scan Manifeseted Shipments</a>
                                <a href="/WarehouseScanner/Delivery" className="list-group-item list-group-item-action">Scan Delivery Shipments</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
            </main>
    </>
  );
}

export default OperationalDashBoard;